import axios from 'axios';
import { Notify } from 'quasar';

export const NOTIFICATION_TYPES = {
  SYSTEM: 'system',
  UPDATE: 'update',
};

export const initialState = {
  notifications: [],
  adminNotifications: [],
};

export const mutations = {
  SET_NOTIFICATIONS(state, newValue) {
    state.notifications = newValue;
  },
  SET_ADMIN_NOTIFICATIONS(state, newValue) {
    state.adminNotifications = newValue;
  },
};

export const getters = {
  systemNotifications: state => state.notifications.filter(n => n.type === NOTIFICATION_TYPES.SYSTEM),
  updateNotifications: state => state.notifications.filter(n => n.type === NOTIFICATION_TYPES.UPDATE),
  unreadCount: state => state.notifications.filter(n => !n.isRead).length,
};

export const actions = {

  getAllNotifications({ commit } = {}) {
    return axios.get('/v2/notifications').then((res) => {
      commit('SET_NOTIFICATIONS', res.data.data);
    });
  },

  closeDialog({ dispatch }, ID) {
    return axios.put(`/v2/notifications/${ID}`, {
      showPopUp: false,
      isRead: true,
    }).then(() => {
      dispatch('getAllNotifications');
    });
  },

  markAllRead({ dispatch }) {
    return axios.put('/v2/notifications/read-all').then(() => {
      dispatch('getAllNotifications');
    });
  },

  handleNewNotification({ dispatch }, msg) {
    const notifyConf = {
      message: `${msg.title}`,
      detail: msg.snippet.substring(0, 50),
      timeout: 10000,
      position: 'bottom-right',
      color: 'grey-9',
      textColor: 'white',
    };

    dispatch('getAllNotifications');

    Notify.create(notifyConf);
  },

  createNotification({ dispatch } = {}, notification) {
    return axios.post('/v2/notifications', notification).then(() => {
      dispatch('getAdminNotifications');
    });
  },

  getAdminNotifications({ commit } = {}) {
    return axios.get('/v2/notifications/admin').then((res) => {
      commit('SET_ADMIN_NOTIFICATIONS', res.data.data);
    });
  },

};


export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
